export default "/app-page/javascript/public/images/medium-bd11294bff807be3.png"